import React, { useEffect, useMemo, useState } from 'react';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import styles from './PhoneInput.module.scss';
import Label from '../label/Label';
import useIpCountry from './factory/useIpCountry';

const PhoneInput_ = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  touched,
  error,
  disabled,
  style,
  required,
  id,
}) => {
  const ipCountry = useIpCountry();
  const defaultCountry = ipCountry || 'US';

  const [selectedCountry, setSelectedCountry] = useState(defaultCountry);
  const [phoneError, setPhoneError] = useState('');

  useEffect(() => {
    if (defaultCountry && !selectedCountry) {
      setSelectedCountry(defaultCountry);
    }
  }, [defaultCountry, selectedCountry]);

  const handlePhoneChange = (val) => {
    onChange?.(val);

    if (!val) {
      setPhoneError('');
      return;
    }

    if (!isValidPhoneNumber(val)) {
      setPhoneError('Invalid phone number');
      return;
    }

    setPhoneError('');
  };

  const handleCountryChange = (country) => {
    setSelectedCountry(country || defaultCountry);

    if (!value) {
      setPhoneError('');
      return;
    }

    if (!isValidPhoneNumber(value)) {
      setPhoneError('Invalid phone number');
      return;
    }

    setPhoneError('');
  };

  const finalError = useMemo(() => {
    if (phoneError) return phoneError;
    if (touched && error) return error;
    return '';
  }, [phoneError, touched, error]);

  return (
    <div className={styles['input-container']} style={style}>
      {label && <Label text={label} required={required} htmlFor={id} />}

      <div className={styles['phone-input-container']}>
        <PhoneInput
          id={id}
          defaultCountry={defaultCountry}
          name={name}
          value={value}
          onChange={handlePhoneChange}
          onBlur={onBlur}
          onCountryChange={handleCountryChange}
          disabled={disabled}
          className={styles['phone-input']}
          countryCallingCodeEditable={false}
          international
          withCountryCallingCode
          limitMaxLength
        />
      </div>

      {finalError && <div className={styles.error}>{finalError}</div>}
    </div>
  );
};

export default PhoneInput_;
